import globalSlice from '../slices/globalSlice'

const globalReducer = {
    global: globalSlice,
};

export default globalReducer;